import logo from "./logo.svg";
import "./App.css";
// import Navbar from './components/Home/Topbar/Navbar';
import Navbar from "./components/Global/Navbar/Navbar";
import Footer from "./components/Global/Footer/Footer";
import { Route, Router, Routes, useLocation } from "react-router-dom";
// index.js or App.js
import "bootstrap/dist/css/bootstrap.min.css";
import Viewdetails from "./pages/viewdetails";
import Blog from "./pages/blog";
import Seemore from "./pages/seemore";
import SignUp from "./Dashboard/SignUp/SignUp";
import LogIn from "./Dashboard/LogIn/LogIn";
import AccountRecovery from "./Dashboard/AccountRecovery/AccountRecovery";
import ResetPassword from "./Dashboard/ResetPassword/ResetPassword";
import Opps from "./Dashboard/404/Opps";
import Dashboard from "./Dashboard/Dashboard";
import Analyze from "./Dashboard/DashboardRightComponents/analyzebrand/analyze";
import Privacy from "./pages/privacy";
import Terms from "./components/privacy/termscondition/terms";
import Home from "./pages/home";
import Protected from "./components/protected/ProtectedRoute";

function App() {
  const location = useLocation();
  const { pathname } = location;
  const shouldShowNavbarFooter = ![
    "/signup",
    "/login",
    "/accountrecovery",
    "/resetpassword",
    "/dashboard",
    "/404",
    "/analyze",
    "/chatbot",
    "analyze",
  ].includes(pathname);

  return (
    <div className="App">
      {shouldShowNavbarFooter && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/viewdetails" element={<Viewdetails />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/seemore" element={<Seemore />} />

        {/* Dashboard Routes */}
        <Route path="/analyze" element={<Analyze />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<LogIn />} />
        <Route path="/accountrecovery" element={<AccountRecovery />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/404" element={<Opps />} />



        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />

        <Route path="/analyze" element={<Analyze />} />
        <Route path="/privacypolicy" element={<Privacy />} />
        <Route path="/termscondition" element={<Terms />} />
        {/* Dashboard Routes */}
      </Routes>
      {shouldShowNavbarFooter && <Footer />}
    </div>
  );
}

export default App;
